import { createContext, useState, useEffect, useContext } from 'react';
import { useUrlDataContext } from './UrlDataContext';

const ActionContext = createContext(null);

export const ActionProvider = ({ children }) => {
  const { currentUrlData } = useUrlDataContext();
  const [view, setView] = useState(currentUrlData?.bestProductMatch?.id ? 'best-match' : 'search');
  const [productId, setProductId] = useState(null);

  useEffect(() => {
    if (currentUrlData?.bestProductMatch?.id) {
      setView('best-match');
    } else {
      setView('search');
    }
  }, [currentUrlData]);

  return <ActionContext.Provider value={{ view, setView, productId, setProductId }}>{children}</ActionContext.Provider>;
};

export const useActionContext = () => {
  const context = useContext(ActionContext);
  if (!context) {
    throw new Error('useActionContext must be used within a ActionProvider');
  }
  return context;
};
